import { checkRequiredFields } from "./common";
import { getEmailErrorMessage } from "./emailValidation";
import {
  getPasswordErrorMessage,
  getConfirmedPasswordErrorMessage,
} from "./passwordValidation";

/**
 * Обязательные поля для формы физ. лица
 */
export const INDIVIDUAL_REQUIRED_FIELDS = {
  fio: "ФИО",
  phoneNumber: "Номер телефона",
  email: "Электронная почта",
  password: "Пароль",
  confirmedPassword: "Подтверждение пароля",
};

const fioPattern = new RegExp(
  "^[а-яА-ЯёЁa-zA-Z]+(-[а-яА-ЯёЁa-zA-Z]+)*( [а-яА-ЯёЁa-zA-Z]+(-[а-яА-ЯёЁa-zA-Z]+)*){1,2}$",
);

export const getFioErrorMessage = (value) => {
  if (!value) return "";
  return fioPattern.test(value.trim())
    ? ""
    : "Введите ФИО в корректном формате";
};

/**
 * Полная валидация формы физ. лица
 * @param {Object} formData - данные формы
 * @returns {Object} - объект с ошибками валидации
 */
export const validateIndividualForm = (formData) => {
  const requiredCheck = checkRequiredFields(
    formData,
    INDIVIDUAL_REQUIRED_FIELDS,
  );

  if (requiredCheck.isEmpty) {
    return {
      fieldErrors: requiredCheck.fieldErrors,
      messages: {
        email: "",
        password: "",
        confirmedPassword: "",
      },
      isValid: false,
      requiredFieldsError: requiredCheck.message,
    };
  }

  const fioError = getFioErrorMessage(formData.fio);
  const emailError = getEmailErrorMessage(formData.email);
  const passwordError = getPasswordErrorMessage(formData.password);
  const confirmedPasswordError = getConfirmedPasswordErrorMessage(
    formData.password,
    formData.confirmedPassword,
  );

  const messages = {
    fio: fioError || "",
    email: emailError || "",
    password: passwordError || "",
    confirmedPassword: confirmedPasswordError || "",
  };

  const hasErrors =
    fioError || emailError || passwordError || confirmedPasswordError;

  return {
    fieldErrors: {
      fio: !!fioError,
      phoneNumber: false,
      email: !!emailError,
      password: !!passwordError,
      confirmedPassword: !!confirmedPasswordError,
    },
    messages,
    isValid: !hasErrors,
    requiredFieldsError: null,
  };
};

/**
 * Валидация полей при потере фокуса
 */
export const individualValidateOnBlur = {
  fio: (value) => getFioErrorMessage(value),
  email: (value) => getEmailErrorMessage(value),
  password: (value) => getPasswordErrorMessage(value),
  confirmedPassword: (value, formData) =>
    getConfirmedPasswordErrorMessage(formData?.password, value),
};

/**
 * Поля, которые нужно очищать при изменении
 */
export const individualClearOnChange = [
  "fio",
  "email",
  "password",
  "confirmedPassword",
];
